import type { FC } from 'react';
import React, { useCallback, useMemo, useState, useRef } from 'react';
import '@/assets/styles/ui-component.less';
import Tag from './components/Tag';
import type { IProps, TTagList } from './IComponent';
import CommonBox from '@/basic/CommonBox/CommonBox';
import { langList, tagPosition } from './lang';
import getCDNPath from '@/utils/shared/getCDNPath';
import useScreenWidthByUA from '@/utils/hooks/useScreenWidthByUA';
import CompBasicTitleWithDesc from '@/basic/TitleWithDesc';

const reolinkHomePc = getCDNPath('/wp-content/assets/reolinkHomePc.jpg');
const reolinkHomeM = getCDNPath('/wp-content/assets/reolinkHomeM.jpg');

const CompReolinkHome: FC<IProps> = (props) => {
    // 优先用传入的，如果传入的没有，那么就根据语言获取，如果三种语言里还没有，那么就显示英语的

    const curLang = langList[props.lang?.toLowerCase() ?? 'en'] ?? langList['en'];

    const tagList: TTagList = useMemo(() => {
        if (props.tagList?.length) {
            return props.tagList;
        }
        return curLang.list;
    }, [curLang.list, props.tagList]);
    const title = props.title ?? curLang.title;

    const screenWidth = useScreenWidthByUA(props.ctx?.headers?.userAgent);

    const [openBubbleIndex, setOpenBubbleIndex] = useState<number | null>(null);
    const wrapRef = useRef<HTMLDivElement>(null);

    const getTagPosition = useCallback((index: number, type: 'Top' | 'Left') =>
        screenWidth < 768 ? tagPosition[index][`mobile${type}`] : tagPosition[index][`pc${type}`],
    [screenWidth]);

    const getImage = useMemo(() => {
        const imagePc = props.imagePc?.src ? props.imagePc : { src: reolinkHomePc, alt: 'ReolinkHome' };
        const imageMobile = props.imageMobile?.src ? props.imageMobile : { src: reolinkHomeM, alt: 'ReolinkHome' };
        return screenWidth >= 768 ? imagePc : imageMobile;
    }, [props.imageMobile, props.imagePc, screenWidth]);

    return (
        <CommonBox style={ props.style }>
            <div className={ 'reolink-home' }>
                <div
                    className={ 'reolink-home-wrap' }
                    ref={ wrapRef }
                >
                    <img
                        className={ 'background-img' }
                        src={ getImage.src }
                        alt={ getImage.alt }
                    />

                    <CompBasicTitleWithDesc
                        title={ title }
                        className='reolink-home-title-content'
                        titleClassName='reolink-home-title'
                    />

                    {
                        //跳转包一层a标签 方便seo
                        tagList ? tagList.map((tag, index) =>
                            (
                                <a
                                    href={ tag.link }
                                    key={ tag.tagName }
                                    onClick={ e => { e.preventDefault(); } }
                                >
                                    <Tag
                                        screenWidth={ screenWidth }
                                        onClick={ () => {
                                            if (screenWidth < 768) {
                                                setOpenBubbleIndex(index);
                                            }
                                            else {
                                                location.href = tag.link;
                                            }
                                        } }
                                        top={ getTagPosition(index, 'Top') }
                                        left={ getTagPosition(index, 'Left') }
                                        tagName={ tag.tagName }
                                        showBubble={ screenWidth < 768 && openBubbleIndex === index }
                                        onBubbleClick={ () => location.href = tag.link }
                                    >
                                    </Tag>
                                </a>
                            )
                        ) : null
                    }
                </div>
            </div>
        </CommonBox>
    );
};

export default CompReolinkHome;
